import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'app-theme';

  isDark = signal(false);

  constructor() {
    if (localStorage.getItem(this.STORAGE_KEY) === 'dark') {
      this.applyDark(true);
    }
  }

  toggle(): void {
    this.applyDark(!this.isDark());
  }

  private applyDark(dark: boolean): void {
    this.isDark.set(dark);
    if (dark) {
      document.documentElement.setAttribute('data-theme', 'dark');
      this.loadDarkCss();
    } else {
      document.documentElement.removeAttribute('data-theme');
      document.getElementById('dark-theme-css')?.remove();
    }
    localStorage.setItem(this.STORAGE_KEY, dark ? 'dark' : 'light');
  }

  private loadDarkCss(): void {
    if (document.getElementById('dark-theme-css')) return;
    const link = document.createElement('link');
    link.id = 'dark-theme-css';
    link.rel = 'stylesheet';
    link.href = 'assets/ng-zorro-antd.dark.min.css';
    document.head.appendChild(link);
  }
}
